import { CartLinesUpdateEvent } from '@shopify/events';

class MnAbitiLookCard extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');
    this.button = this.querySelector('button[type="submit"]');
    this.status = this.querySelector('[role="status"]');
    this.select.addEventListener('change', () => this.updateVariant(), { signal: this.controller.signal });
    this.form.addEventListener('submit', event => this.add(event), { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  updateVariant() {
    const option = this.select.selectedOptions[0];
    if (!option) return;
    this.querySelector('[data-look-price]').textContent = option.dataset.price;
    const compare = this.querySelector('[data-look-compare]');
    const discount = this.querySelector('[data-look-discount]');
    compare.textContent = option.dataset.compare;
    compare.hidden = discount.hidden = Number(option.dataset.discount) <= 0;
    discount.textContent = `−${option.dataset.discount}%`;
    this.querySelectorAll('[data-look-link]').forEach(link => { link.href = option.dataset.url; });
    const image = this.querySelector('img');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    this.button.disabled = option.dataset.available !== 'true';
    this.button.textContent = this.button.disabled ? this.dataset.soldOut : this.dataset.add;
    this.status.hidden = true;
    this.querySelector('.mn-abiti-look__cart-link').hidden = true;
  }
  async add(event) {
    event.preventDefault();
    if (this.busy || this.button.disabled) return;
    const body = new FormData(this.form);
    const variantId = String(body.get('id'));
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
    body.set('sections', sections.join(','));
    body.set('sections_url', location.pathname);
    this.busy = true;
    this.button.disabled = true;
    this.select.disabled = true;
    this.button.textContent = this.dataset.adding;
    this.status.hidden = true;
    this.setAttribute('aria-busy', 'true');
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise }));
    let added = false;
    try {
      const response = await fetch(this.form.action.replace(/\/$/, '') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      added = true;
      const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error(this.dataset.refreshError);
      const cart = await cartResponse.json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mn-abiti-look', sourceId: this.form.id, itemCount: 1, productId: this.dataset.productId, sections: result.sections, didError: false } });
      this.status.textContent = this.dataset.added;
      this.button.textContent = this.dataset.added;
      this.querySelector('.mn-abiti-look__cart-link').hidden = false;
    } catch (error) {
      deferred.reject(error);
      this.status.textContent = added ? this.dataset.refreshError : error.message || this.dataset.error;
      this.button.textContent = added ? this.dataset.added : this.dataset.add;
      this.querySelector('.mn-abiti-look__cart-link').hidden = !added;
    } finally {
      this.busy = false;
      this.select.disabled = false;
      this.button.disabled = added;
      this.status.hidden = false;
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('mn-abiti-look-card')) customElements.define('mn-abiti-look-card', MnAbitiLookCard);
